export default "/images/icon_book.png?6ff4cae9ec843cb4eb4468ca4c8e80ed";